import React, { memo, ReactElement, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Button } from 'reactApp/ui/Button/Button';
import Countdown from 'reactApp/ui/Countdown/Countdown';
import { ICountdownPromo } from 'reactApp/ui/Space/SpaceCountdown/SpaceCountdown.data';
import { getPromoCountdownEndDate } from 'reactApp/ui/Space/spacePromo';
import { createGaSender } from 'reactApp/utils/ga';

import styles from './SpaceCountdown.css';

const sendGaCountdown = createGaSender('ab-space-countdown');

export const SpaceCountdown = memo(({ id, img, text, onClick }: ICountdownPromo): ReactElement => {
    const userEmail = useSelector(UserSelectors.getEmail);

    useEffect(() => {
        sendGaCountdown('show', id);
    }, []);

    const handleClick = useCallback(() => {
        sendGaCountdown('click', id);
        onClick();
    }, [onClick]);

    return (
        <div className={styles.root} onClick={handleClick}>
            <div className={styles.info}>
                <div className={styles.description}>
                    <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
                    <div className={styles.timer}>
                        <Countdown showIcon showAsPlainText theme="dark" endDate={getPromoCountdownEndDate(userEmail)} />
                    </div>
                </div>
                <div>{img}</div>
            </div>
            <div className={styles.button}>
                <Button primary fluid theme="octavius">
                    <div className={styles.text}>Увеличить объем</div>
                </Button>
            </div>
        </div>
    );
});

SpaceCountdown.displayName = 'SpaceCountdown';
